// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"UJCSm","rc-tabs-tab-active":"IiXyC","input-suffix":"q6G2n","nav-item":"_6y-Pn","banner":"yY4qB","banner-info":"_4Fxhm","banner-info-content":"LTEVG"};